import { toBig } from '@/composables/useInvoiceCalculations';

export const PURCHASE_VAT_RATES = [20, 0];
export const DEFAULT_PURCHASE_VAT_RATE = PURCHASE_VAT_RATES[0];

const amount = (value) => value == null || String(value).trim() === '' ? null : toBig(value);
const fixed = (value) => {
  const result = toBig(value).toFixed(2);
  return result === '-0.00' ? '0.00' : result;
};

export const inferPurchaseVatRate = (record = {}) => {
  const vat = amount(record.vat), gross = amount(record.gross), net = amount(record.net);
  if (vat !== null && vat.abs().gt(0.009)) return DEFAULT_PURCHASE_VAT_RATE;
  if (gross !== null && net !== null && gross.minus(net).abs().lt(0.01)) return 0;
  return DEFAULT_PURCHASE_VAT_RATE;
};

// Both the journal and invoice import use the same editable money-field calculation.
export const recalculatePurchaseAmounts = (record, changedField, rate = DEFAULT_PURCHASE_VAT_RATE) => {
  if (!record || !['gross', 'net', 'vat'].includes(changedField)) return;
  const gross = amount(record.gross), net = amount(record.net), vat = amount(record.vat);
  if (amount(record[changedField]) === null) {
    record.gross = ''; record.net = ''; record.vat = '';
    return;
  }
  const fraction = toBig(rate).div(100);
  const set = (field, value) => { record[field] = fixed(value); };
  if (changedField === 'gross') {
    // Subtract the rounded Net so the displayed amounts also add up to Gross.
    const nextNet = gross.div(fraction.plus(1)).round(2);
    set('net', nextNet);
    set('vat', gross.round(2).minus(nextNet));
  } else if (changedField === 'net') {
    const nextVat = net.times(fraction).round(2);
    set('vat', nextVat);
    set('gross', net.round(2).plus(nextVat));
  } else if (fraction.eq(0)) {
    if (gross !== null && net === null) set('net', gross);
    else if (net !== null && gross === null) set('gross', net);
  } else {
    const nextNet = vat.div(fraction).round(2);
    set('net', nextNet);
    set('gross', nextNet.plus(vat.round(2)));
  }
};
